import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useAccessDeniedStore } from "./AccessDeniedStore";
import { useTranslation } from "react-i18next";

export function AccessDeniedModal() {
    const { t } = useTranslation();
    const { isOpen, hide } = useAccessDeniedStore();

    return (
        <Modal isOpen={isOpen} toggle={hide} centered={true}>
            <ModalHeader toggle={hide}>{t("Access Denied")}</ModalHeader>
            <ModalBody className="text-center p-4">
                <div className="mb-4">
                    <i className="ri-error-warning-line text-danger" style={{ fontSize: "60px" }}></i>
                    <h5>{t("Contact Admin Message")}</h5>

                </div>
                <p>{t("You do not have permission to access this page. Please contact the administrator for more information: ")} <a href="mailto:contact@clickorder.io">contact@clickorder.io</a> </p>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={hide}>
                    {t("OK")}
                </Button>
            </ModalFooter>
        </Modal>
    );
}
